import { Avatar, Button, fetchRoute, GenericWrapperContext, getBrandUrl, Icon, Typography } from "cakemail-ui-components-v2"
import { useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import { Stack } from "@mui/material"
import { ERoutes } from "../../utils/url"

export function MenuSettings({ onGearClick, onLogout }: { onGearClick: () => void, onLogout: () => void }) {
    const genericWrapperContext = useContext(GenericWrapperContext)
    const [openedSettings, setOpenedSettings] = useState<boolean>(false)
    const { t } = useTranslation()

    function handleToggleSettings() {
        setOpenedSettings(!openedSettings)
    }

    return <Stack className="footer appMenuSettings" direction="row" gap={2} >
        <Avatar variant='square' email={genericWrapperContext?.user?.email} firstName={genericWrapperContext?.user?.first_name} lastName={genericWrapperContext?.user?.last_name} sizes={42} />

        <Stack direction="row" gap={2} justifyItems="space-between" className={`appMenuSettingsClosedButtons ${openedSettings ? "hidden" : "show"}`}>
            <Stack direction="row" gap={2} >
                <Button color="primary" size="small" variant='outlined' onClick={handleToggleSettings} >
                    <Avatar variant='square' email={genericWrapperContext?.user?.email} firstName={genericWrapperContext?.user?.first_name} lastName={genericWrapperContext?.user?.last_name} sizes={26} />
                    <img src={getBrandUrl({ brand: genericWrapperContext?.partnerBrand, elKey: "logo" })} alt="logo" />
                </Button>
                <Button color="body1" size="small" variant='outlined' onClick={onGearClick} >
                    <Icon name="Settings18" />
                </Button>
            </Stack>

            <Button color="secondary" size="small" variant='outlined' onClick={() => {
                window.location.href = "#" + fetchRoute({ route: ERoutes.billing })
            }}>
                {t("general-upgrade")}
            </Button>
        </Stack>


        <Stack direction="column" gap={6} justifyContent="space-between" className={`appMenuSettingsOpened ${openedSettings ? "show" : "hidden"}`}>

            <Stack direction="row" gap={4} alignItems="center" className="userInfo">
                <Stack direction="row" gap={4} alignItems="center" >
                    <Avatar variant='square' email={genericWrapperContext?.user?.email} firstName={genericWrapperContext?.user?.first_name} lastName={genericWrapperContext?.user?.last_name} sizes={40} />
                    <Stack direction="column" >
                        <Typography variant="body1L" className="ellipsis" >{genericWrapperContext?.user?.first_name || ""} {genericWrapperContext?.user?.last_name || ""}</Typography>
                        <Typography variant="body1" color="shade500.main" className="ellipsis" >{genericWrapperContext?.user?.email}</Typography>
                    </Stack>
                </Stack>

                <Icon name="X18" onClick={handleToggleSettings} />
            </Stack>

            <Stack direction="row" gap={4} justifyContent="flex-end" >
                <Button color="shade100" size="small" variant='contained' onClick={onLogout} >
                    {t("general-logout")}
                </Button>
            </Stack>


        </Stack>

    </Stack>
}